import { render, staticRenderFns } from "./TramiteItem.vue?vue&type=template&id=2cbd550b&"
import script from "./TramiteItem.vue?vue&type=script&lang=js&"
export * from "./TramiteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports